export const coverflow_data = [
  {
    img: "/images/products/item_13_lg.jpg",
    title: "Etherium NFT Launching Lab",
    authorImage: "/images/avatars/avatar_18_rounded.gif",
    authorName: "051_Hart",
    id: "0Etherium NFT Launching Lab",
  },
  {
    img: "/images/products/item_16_lg.jpg",
    title: "Oceania  OVERSEER 017",
    authorImage: "/images/avatars/avatar_22_rounded.jpg",
    authorName: "MadeByM1KE",
    id: "1Oceania  OVERSEER 017",
  },
  {
    img: "/images/products/item_12_lg.jpg",
    title: "Light Bars",
    authorImage: "/images/avatars/avatar_17_rounded.jpg",
    authorName: "Wow Frens",
    id: "2Light Bars",
  },
  {
    img: "/images/products/item_14_lg.jpg",
    title: "Amazing NFT art",
    authorImage: "/images/avatars/avatar_19_rounded.jpg",
    authorName: "Lila Spacex",
    id: "3Amazing NFT art",
  },
  {
    img: "/images/products/item_15_lg.jpg",
    title: "SwagFox#133",
    authorImage: "/images/avatars/avatar_20_rounded.jpg",
    authorName: "Bored Bunny",
    id: "4SwagFox#133",
  },
  {
    img: "/images/products/item_13_lg.jpg",
    title: "Etherium NFT Launching Lab",
    authorImage: "/images/avatars/avatar_18_rounded.gif",
    authorName: "051_Hart",
    id: "5Etherium NFT Launching Lab",
  },
  {
    img: "/images/products/item_16_lg.jpg",
    title: "Oceania  OVERSEER 017",
    authorImage: "/images/avatars/avatar_22_rounded.jpg",
    authorName: "MadeByM1KE",
    id: "6Oceania  OVERSEER 017",
  },
  {
    img: "/images/products/item_12_lg.jpg",
    title: "Light Bars",
    authorImage: "/images/avatars/avatar_17_rounded.jpg",
    authorName: "Wow Frens",
    id: "7Light Bars",
  },
  {
    img: "/images/products/item_14_lg.jpg",
    title: "Amazing NFT art",
    authorImage: "/images/avatars/avatar_19_rounded.jpg",
    authorName: "Lila Spacex",
    id: "8Amazing NFT art",
  },
  {
    img: "/images/products/item_15_lg.jpg",
    title: "SwagFox#133",
    authorImage: "/images/avatars/avatar_20_rounded.jpg",
    authorName: "Bored Bunny",
    id: "9SwagFox#133",
  },
  {
    img: "/images/products/item_13_lg.jpg",
    title: "Etherium NFT Launching Lab",
    authorImage: "/images/avatars/avatar_18_rounded.gif",
    authorName: "051_Hart",
    id: "10Etherium NFT Launching Lab",
  },
  {
    img: "/images/products/item_16_lg.jpg",
    title: "Oceania  OVERSEER 017",
    authorImage: "/images/avatars/avatar_22_rounded.jpg",
    authorName: "MadeByM1KE",
    id: "11Oceania  OVERSEER 017",
  },
  {
    img: "/images/products/item_12_lg.jpg",
    title: "Light Bars",
    authorImage: "/images/avatars/avatar_17_rounded.jpg",
    authorName: "Wow Frens",
    id: "12Light Bars",
  },
  {
    img: "/images/products/item_14_lg.jpg",
    title: "Amazing NFT art",
    authorImage: "/images/avatars/avatar_19_rounded.jpg",
    authorName: "Lila Spacex",
    id: "13Amazing NFT art",
  },
  {
    img: "/images/products/item_15_lg.jpg",
    title: "SwagFox#133",
    authorImage: "/images/avatars/avatar_20_rounded.jpg",
    authorName: "Bored Bunny",
    id: "14SwagFox#133",
  },
];

export const hero_5_data = [
  {
    img: "/images/products/item_16_2lg.jpg",
    title: "Etherium NFT Launching Lab",
    authorImage: "/images/avatars/avatar_18_rounded.gif",
    authorName: "051_Hart",
    id: "0Etherium NFT Launching Lab",
  },
  {
    img: "/images/products/item_12_2lg.jpg",
    title: "Oceania  OVERSEER 017",
    authorImage: "/images/avatars/avatar_22_rounded.jpg",
    authorName: "MadeByM1KE",
    id: "1Oceania  OVERSEER 017",

    subItem: [
      {
        img: "/images/products/item_13_lg.jpg",
        title: "Light Bars",
        authorImage: "/images/avatars/avatar_17_rounded.jpg",
        authorName: "Wow Frens",
        id: "2Light Bars",
      },
    ],
  },
];
